export default __webpack_public_path__ + "static/media/Factory08.26098c2a.jpg";